import React from 'react';
import styled from 'styled-components';
const BackgroundWrapper = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  background-image: url('/exfluency_wall_QHD-3.jpg');
  background-attachment: fixed;
`;
const Background = ({ children }) => {
    return (React.createElement(BackgroundWrapper, null, children));
};
export default Background;
